import React, { Component } from "react";

import IconCheck        from "material-ui/svg-icons/navigation/check";
import IconClear        from "material-ui/svg-icons/content/clear";

//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import ErrorMessage from "../Components/component_MsgError";
import WorkInProgress   from "../Images/work-in-progress.png";
import "../CSS/style_SceltaVersione.css";

import * as ROUTE from "../Utils/Strings/Route";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";

const styles = {
    pageContainer : {
    },
    versionList : {
        listStyle : "none",
        overflow  : "hidden",
        width : "100%",
        padding : 0,
        listStyleType : "none"
    },
    versionListElement : {
        float : "left",
        border: "1px solid black",
        width: "300px",
        height: "400px",
        padding: "10px",
        margin: "30px",
        background: "white"
    },
    versionListElementTitle : {
        width: "100%",
        textTransform: "uppercase",
        textAlign: "center",
        color : "#6b9add",
        fontSize : "30px"
    },
    versionListElementFunctionality: {
        listStyle : "none",
    }
}

class SceltaVersione extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className="page-container">
        <ErrorMessage message={this.props.errorMessage} />
        <div >
            <div className="pageTile">
                Versioni BilApp
            </div>
            <div className="version-list-container">
                <ul style={styles.versionList}>
                {/*FREE*/}
                <li className="version-list-element">
                    <div style={styles.versionListElementTitle}>
                        Free
                    </div>
                    
                    <table className="functionality">
                        <tr>
                            <th>Funzionalita'</th>
                            <th>Singola</th>
                            <th>Multipla</th>
                        </tr>
                        <tr>
                            <td>Bilance</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Impianti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Aziende</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampanti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampe Personalizzate</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Campi Personalizzati</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Tabelle Personalizzate</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Condivisione Dati</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                    </table>
                    <div className="price">
                        Prezzo : Gratis
                    </div>
                    <div className="button">
                        <div>Scarica Adesso</div>
                    </div>
                </li>
                {/*PRO*/}
                <li className="version-list-element">
                    <div style={styles.versionListElementTitle}>
                        Pro
                    </div>
                    <table className="functionality">
                        <tr>
                            <th>Funzionalita'</th>
                            <th>Singola</th>
                            <th>Multipla</th>
                        </tr>
                        <tr>
                            <td>Bilance</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Impianti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Aziende</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampanti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampe Personalizzate</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                        <tr>
                            <td>Campi Personalizzati</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Tabelle Personalizzate</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Condivisione Dati</td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                            <td><div><IconClear className="icon-clear"/></div></td>
                        </tr>
                    </table>
                    <div className="price">
                        Prezzo : 100,00 €/-
                    </div>
                    <div className="button" onClick={() => PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)}>
                        <div>Registrati</div>
                    </div>
                </li>
                {/*CLOUD*/}
                <li className="version-list-element">
                    <div style={styles.versionListElementTitle}>
                        Cloud
                    </div>
                    <table className="functionality">
                        <tr>
                            <th>Funzionalita'</th>
                            <th>Singola</th>
                            <th>Multipla</th>
                        </tr>
                        <tr>
                            <td>Bilance</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Impianti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Aziende</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampanti</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Stampe Personalizzate</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Campi Personalizzati</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Tabelle Personalizzate</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                        <tr>
                            <td>Condivisione Dati</td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                            <td><div><IconCheck className="icon-check"/></div></td>
                        </tr>
                    </table>
                    <div className="price">
                        Prezzo : 100,00 €/Anno
                    </div>
                    <div className="button" onClick={() => PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)}>
                        <div>Registrati</div>
                    </div>
                </li>
            </ul>
            </div>
            
            <div>
                

            </div>
        </div>
      </div>;
  }
}

export default (SceltaVersione);


// WEBPACK FOOTER //
// ./src/Containers/SceltaVersione.js